import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { CustoMedio } from 'src/app/admihair/api/dto/custo-medio';
import { ItemProdutoVw } from 'src/app/admihair/api/dto/item-produto-vw';
import { CustoService } from 'src/app/admihair/service/custo.service';
import { EntradaEstoqueService } from 'src/app/admihair/service/entrada-estoque.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { AdmihairBaseComponent } from '../../admihair-base.component';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-item-produto-resumo-janela',
  templateUrl: './item-produto-resumo-janela.component.html',
  styleUrls: ['./item-produto-resumo-janela.component.scss']
})
export class ItemProdutoResumoJanelaComponent extends AdmihairBaseComponent implements OnInit {

  id?: number;
  itemProdutoVw?: ItemProdutoVw;
  loading: boolean = true;


  custoMedio: CustoMedio = {
    custoFixo: 0,
    imposto: 0
  };
  custoTotal: number = 0;
  percentualFrete: number = 0;
  valorVenda: number = 0;
  valorLucroDesejado: number = 0;
  valorLucroObtido: number = 0;
  valorSugerido: number = 0;
  novoValor: number = 0;
  valorLucroObtidoAtual: number = 0;
  percentualLucroObtidoAtual: number = 0;
  loadingSpinnerDialog: boolean = false;

  constructor(private activatedRouter: ActivatedRoute,
    private itemProdutoService: ItemProdutoService,
    private entradaEstoqueService: EntradaEstoqueService,
    private custoService: CustoService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router?: Router,
    activatedRoute?: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.carregarIdItemProduto();
    this.carregarItemProdutoPorId();
  }

  carregarIdItemProduto() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }

  carregarItemProdutoPorId() {
    this.itemProdutoService.buscarDadosItemProdutoPorId(this.id).subscribe({
      next: (data: ItemProdutoVw) => {
        this.itemProdutoVw = data;
        this.obterCustos();
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  abrirUrlProduto() {
    window.open(this.itemProdutoVw?.urlDetalheProduto, '_blank');
  }


  obterCustos() {
    this.custoService.obterDadosParaPrecificacao(this.getEmpresa().id).subscribe({
      next: (data: CustoMedio) => {
        this.custoMedio = data;
        this.buscarPercentualFrete();
      },
      error: (err: any) => {
        this.loadingSpinnerDialog = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  buscarPercentualFrete() {
    this.entradaEstoqueService.buscarPercentualFreteUltimaEntrada(
      this.getEmpresa().id,
      this.itemProdutoVw?.id
    ).subscribe({
      next: (data: number) => {
        this.percentualFrete = data;
        this.calcularLucroObtidoAtual();
        this.calcularValorSugerido();
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  private calcularValorCompra(): number {
    const valorCompra = this.itemProdutoVw?.valorCompra ?? 0;
    const quantidade = this.itemProdutoVw?.quantidadeUnidadeMedida ?? 1;

    if (quantidade > 1) {
      return valorCompra / quantidade;
    }
    return valorCompra;
  }

  private calcularValorFrete(valorCompra: number): number {
    return valorCompra * (this.percentualFrete / 100);
  }

  private calcularPercentualCusto(): number {
    const custoFixo = this.custoMedio?.custoFixo ?? 0;
    const comissao = this.itemProdutoVw?.comissaoVenda ?? 0;
    const imposto = this.custoMedio?.imposto ?? 0;
    return custoFixo + comissao + imposto;
  }

  calcularValorSugerido(): void {
    if (!this.itemProdutoVw?.lucro) {
      this.valorSugerido = 0;
      return;
    }

    const valorCompra = this.calcularValorCompra();
    const valorFrete = this.calcularValorFrete(valorCompra);
    const valorLucroDesejado = valorCompra * (this.itemProdutoVw.lucro / 100);
    const valorComposicao = valorCompra + valorFrete + valorLucroDesejado;

    const percentualCusto = this.calcularPercentualCusto();
    const valorInicial = valorComposicao + (percentualCusto * valorComposicao / 100);
    const diferencaComposicao = (valorInicial - valorComposicao) * (percentualCusto / 100);

    const valorCalculado = valorInicial + diferencaComposicao + (diferencaComposicao * percentualCusto / 100);
    this.valorSugerido = valorCalculado;
  }

  calcularLucroObtidoAtual(): void {
    const valorCompra = this.calcularValorCompra();
    const valorFrete = this.calcularValorFrete(valorCompra);
    const valorVenda = this.itemProdutoVw?.valorVenda ?? 0;
    const percentualCusto = this.calcularPercentualCusto();

    const valorCustoReais = valorVenda * (percentualCusto / 100);
    this.valorLucroObtidoAtual = valorVenda - valorCompra - valorFrete - valorCustoReais;
    this.percentualLucroObtidoAtual = this.valorLucroObtidoAtual / valorVenda
    this.custoTotal = (this.custoMedio.custoFixo + this.custoMedio.imposto) / 100;
  }

  calcularLucroObtido(valor?: number): void {
    this.novoValor = valor ?? 0;

    if (this.novoValor <= 0) {
      this.valorLucroObtido = 0;
      return;
    }

    const valorCompra = this.calcularValorCompra();
    const valorFrete = this.calcularValorFrete(valorCompra);
    const percentualCusto = this.calcularPercentualCusto();

    const valorCustoReais = this.novoValor * (percentualCusto / 100);
    this.valorLucroObtido = this.novoValor - valorCompra - valorFrete - valorCustoReais;
  }

}
